import '../css/main.css';
import 'virtual:auto-styles';
import 'virtual:auto-scripts';

import 'fslightbox';

import Alpine from 'alpinejs'

// Make Alpine available globally
window.Alpine = Alpine

// Start Alpine
Alpine.start()
// Helpers
import './helpers/load-more-posts.js';

// require('./helpers/scroll-animation/scroll-animation.js');
// require('./helpers/Parallax/parallax.js');


